<template>
  <div class="containerTable">
    <div class="container_account_box">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane
          v-for="(item, index) in platformList"
          :label="item.branchName"
          :name="item.branchCode"
          :key="index"
          v-loading="amountLoading"
        >
          <cardInfo
            :accountAmount="accountAmount"
            :accountTax="accountTax"
            :currentCompany="platformList[activeIndex]"
            @branchGetSelfBlance="branchGetSelfBlance"
            @branchGetSelfBlance2="branchGetSelfBlance2"
            @refreshCompany="refreshCompany"
          ></cardInfo>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import cardInfo from "@/components/accountInfo/cardInfo.vue";
import { branchGetSelfBlance, getPlatformInfo } from "@/api/shipment.js";
import compAdd from "./components/platformHouseholdAdd.vue";
import compEdit from "./components/platformHouseholdEdit.vue";
import compDetail from "./components/platformHouseholdDetail.vue";
import request from "@/utils/request";
export default {
  name: "PlatformHouseholdList",
  components: {
    cardInfo,
    compAdd,
    compEdit,
    compDetail
  },
  data() {
    return {
      amountLoading: false,
      activeIndex: 0,
      activeTab: "",
      loaingAmount: false,
      loaingTax: false,
      message: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      exportObj: {
        exportUrl: "/ntocc-basic-api/platformHousehold/exportPlatformHousehold", //导出接口
        name: "平台公户"
      },
      listQuery: {
        gmtCreatedRange: "",
        gmtModifiedRange: "",
        code: "",
        isDefault: "",
        bankBranch: "",
        associateBankNumber: "",
        bankCity: "",
        bankProvince: "",
        bankName: "",
        bankNum: "",
        phone: "",
        companyName: "",
        branchCode: "",
        modifiedByName: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      defaultOptions: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
      BankTypeOptions: [
        { label: "转账支付", value: 1 },
        { label: "银行支付", value: 0 }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      platformHousehold_detail_button: false,
      platformHousehold_edit_button: false,
      platformHousehold_delete_button: false,

      value: "",
      accountAmount: null,
      accountTax: null,
      platformList: null
      // Pagingconf:[]
    };
  },
  created() {
    this.getPlatformInfoApi();
  },
  methods: {
    refreshCompany() {
      Promise.all([
        this.branchGetSelfBlance(),
        this.branchGetSelfBlance2()
      ]).then(results => {
        this.amountLoading = false;
      });
    },
    // 获取平台tab
    getPlatformInfoApi() {
      getPlatformInfo().then(res => {
        if (res.status === 0) {
          this.platformList = res.data.list;
          this.activeTab = this.platformList[0].branchCode;
          // this.branchGetSelfBlance();
          // this.branchGetSelfBlance2();
          this.amountLoading = true;
          Promise.all([
            this.branchGetSelfBlance(),
            this.branchGetSelfBlance2()
          ]).then(results => {
            this.amountLoading = false;
          });
        }
      });
    },

    // 刷新余额
    refreshBalance() {
      // 开始旋转
      this.loaingAmount = true;

      // 模拟API请求
      setTimeout(() => {
        // 请求成功后停止旋转
        this.loaingAmount = false;
        this.$message.success("余额已刷新");
      }, 1000);
    },
    // 余额
    async branchGetSelfBlance(type = "") {
      this.loaingAmount = true;
      let data = {
        branchCode: this.activeTab,
        virAccType: "1"
      };
      let res = await branchGetSelfBlance(data);
      if (res.status === 0) {
        this.accountAmount = res.data.blance;
        this.loaingAmount = false;
        if (type === "refresh") this.$message.success("余额已刷新");
      }
      console.log("branchGetSelfBlance=========", res);
    },
    // 利息
    async branchGetSelfBlance2(type = "") {
      this.loaingTax = true;
      let data = {
        branchCode: this.activeTab,
        virAccType: "2"
      };
      let res = await branchGetSelfBlance(data);
      if (res.status === 0) {
        this.loaingTax = false;
        if (type === "refresh") this.$message.success("利息已刷新");
        this.accountTax = res.data.blance;
      }
      console.log("branchGetSelfBlance=========", res);
    },
    // 标签切换处理
    handleTabChange(tab) {
      console.log("切换到标签:", tab);
      console.log("切换到标签!!!!!!!!:", this.activeTab);
      this.activeIndex = +tab.index;
      this.amountLoading = true;
      Promise.all([
        this.branchGetSelfBlance(),
        this.branchGetSelfBlance2()
      ]).then(results => {
        this.amountLoading = false;
      });
    },

    // 提现操作
    withdraw() {
      this.$message.warning("提现功能开发中");
    }
  }
};
</script>
<style scoped lang="scss">
.item_height {
  height: 680px;
  overflow: hidden;
}
.account_info_title {
  display: flex;
  align-items: flex-end;
  margin-bottom: 40px;
  .title_h2 {
    font-size: 20px;
    font-weight: bold;
    margin-right: 20px;
  }
}

.account_info_tips {
  color: #a3a3a3;
}

.account_info_row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: 1px dashed #ebeef5;
}

.account_info_label {
  width: 100px;
  color: #606266;
  font-weight: 600;
  margin-right: 15px;
  text-align: right;
  font-size: 15px;
}

.account_info_value {
  color: #303133;
  font-size: 15px;
  flex: 1;
}

.container_account_box {
  padding: 30px;
}
.container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 15px;
}

.account-card,
.record-card {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.company-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #2a6efd;
}

.balance-row {
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin-bottom: 30px;
}

.balance-row > span {
  margin-right: 10px;
}

.highlight {
  font-size: 18px;
  color: #f56c6c;
  margin-right: 8px;
  margin-left: 8px;
}

.bank-account {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.bank-account i {
  margin-left: 8px;
  color: #2a6efd;
}

.refresh_btn_box {
  display: flex;
  align-items: center;
}

.refresh_btn_text {
  margin-right: 3px;
  color: #2a6efd;
}
.refresh_icon {
  color: #2a6efd;
  transition: all 0.3s;
  cursor: pointer;
}

.refresh_icon.rotating {
  animation: rotate-refresh 1s linear infinite;
}

@keyframes rotate-refresh {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.help-tips {
  margin-top: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}

.help-tips p {
  margin: 5px 0;
}

/* 轮播相关样式 */
.record-carousel-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  // overflow: hidden;
}

.record-type-buttons {
  padding: 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  // justify-content: center;
}

.el-carousel {
  height: 680px;
}

.el-carousel__item {
  padding: 20px;
  // overflow-y: auto;
}

/* 确保轮播项内容不会溢出 */
.el-carousel__container {
  height: 100%;
}
</style>
